var map = {
	"./font/AlimamaShuHeiTi-Bold.ttf": "4791",
	"./font/MicrosoftYaHei.ttf": "0fc7",
	"./font/Slidexiaxing-Regular.ttf": "096f",
	"./font/font.css": "3394",
	"./image/AI_PLAZA.png": "0b15",
	"./image/AfterSales_icon.png": "f4bd",
	"./image/BFC.png": "db10",
	"./image/ERcode.png": "a47f",
	"./image/JoinUs_icon1.png": "d457",
	"./image/JoinUs_icon10.png": "786d",
	"./image/JoinUs_icon2.png": "64d9",
	"./image/JoinUs_icon3.png": "cfba",
	"./image/JoinUs_icon4.png": "fd68",
	"./image/JoinUs_icon5.png": "a483",
	"./image/JoinUs_icon6.png": "ced1",
	"./image/JoinUs_icon7.png": "8ae0",
	"./image/JoinUs_icon8.png": "f616",
	"./image/JoinUs_icon9.png": "f732",
	"./image/NanGang.png": "a9c4",
	"./image/QiBao.png": "a49b",
	"./image/QiBao_bigPic.png": "06d2",
	"./image/QianShu.png": "4ed5",
	"./image/RuiAn.png": "5734",
	"./image/RuiAn_icon.png": "2547",
	"./image/SCPG_icon.png": "9a71",
	"./image/SongJiang.png": "0e09",
	"./image/TaxService.png": "6c8a",
	"./image/TaxServiceLOGO.png": "63b3",
	"./image/WuHan.png": "4ef6",
	"./image/YinXiang.png": "5e73",
	"./image/aboutUs_icon1.png": "d9d9",
	"./image/aboutUs_icon2.png": "8c7c",
	"./image/aboutUs_icon3.png": "8ac1",
	"./image/aboutUs_icon4.png": "62b7",
	"./image/aboutUs_icon5.png": "fbf8",
	"./image/aboutUs_icon6.png": "cf42",
	"./image/aboutUs_icon7.png": "e8eb",
	"./image/aboutUs_icon8.png": "e37f",
	"./image/aboutUs_img1.svg": "87c3",
	"./image/aboutUs_img10.svg": "e126",
	"./image/aboutUs_img11.svg": "d844",
	"./image/aboutUs_img12.svg": "6671",
	"./image/aboutUs_img13.svg": "c974",
	"./image/aboutUs_img14.svg": "237f",
	"./image/aboutUs_img15.svg": "c091",
	"./image/aboutUs_img16.svg": "72af",
	"./image/aboutUs_img3.svg": "2501",
	"./image/aboutUs_img4.svg": "1289",
	"./image/aboutUs_img5.svg": "8f08",
	"./image/aboutUs_img6.svg": "222b",
	"./image/aboutUs_img7.svg": "ca49",
	"./image/aboutUs_img8.svg": "a662",
	"./image/aboutUs_pic1.png": "e5e1",
	"./image/aboutUs_pic2.png": "31f5",
	"./image/arrow_left.png": "b9c1",
	"./image/arrow_right.png": "94df",
	"./image/arrow_right_white.png": "0433",
	"./image/backTopBar.png": "f49b",
	"./image/banner.png": "5b08",
	"./image/bannerArrow.png": "3cd2",
	"./image/banner_AIPlaza.png": "fb89",
	"./image/banner_SOLANA.png": "2f80",
	"./image/banner_iv1.png": "40e5",
	"./image/banner_iv2.png": "ac10",
	"./image/banner_iv3.png": "f737",
	"./image/banner_mobile.png": "0398",
	"./image/banner_ms_case1.png": "7e68",
	"./image/banner_ms_case2.png": "48f2",
	"./image/banner_shanghaiMember.png": "e809",
	"./image/banner_songjiang.png": "bb28",
	"./image/banner_wuhan.png": "61b6",
	"./image/banner_yinxiang.png": "872e",
	"./image/business.png": "074e",
	"./image/caijing.png": "0d41",
	"./image/caijingLOGO.png": "9639",
	"./image/case_right.png": "869b",
	"./image/changjiang.png": "d656",
	"./image/changjiangLOGO.png": "1d89",
	"./image/closeBtn.png": "2333",
	"./image/cursorPoint.png": "3758",
	"./image/customerService_icon.png": "284a",
	"./image/dialog_icon.png": "cbfa",
	"./image/fudan.png": "5cf1",
	"./image/fudanLOGO.png": "02c0",
	"./image/fuxingLOGO.png": "27eb",
	"./image/gongxiao.png": "73c2",
	"./image/gongxiaoLOGO.png": "4d2d",
	"./image/gov1.png": "a11c",
	"./image/gov2.png": "783a",
	"./image/iv_b2_pic1.png": "ca4e",
	"./image/iv_b2_pic2.png": "44c2",
	"./image/iv_b2_pic3.png": "13a7",
	"./image/iv_b4_img1.png": "9011",
	"./image/iv_b4_img2.png": "c5f8",
	"./image/iv_b4_img3.png": "72cc",
	"./image/iv_b4_img4.png": "020a",
	"./image/joinUs_block2.png": "8119",
	"./image/kaideLOGO.png": "408d",
	"./image/kaide_minhang.png": "52a5",
	"./image/kongjiang.png": "063a",
	"./image/kongjiangLOGO.png": "e2d0",
	"./image/logo.svg": "155f",
	"./image/maintenance_icon.png": "9001",
	"./image/mm_b1_img1.png": "aae0",
	"./image/mm_b1_img2.png": "ab81",
	"./image/mm_b1_img3.png": "9987",
	"./image/mm_b1_img4.png": "32d3",
	"./image/mm_b2_pic1.png": "98cd",
	"./image/mm_b2_pic2.png": "434a",
	"./image/mm_b2_pic3.png": "df23",
	"./image/mm_b2_pic4.png": "097f",
	"./image/mobile_banner_interactiveView.png": "66d8",
	"./image/mobile_banner_memberMarking.png": "49b0",
	"./image/mobile_banner_merchantServices.png": "2373",
	"./image/mobile_banner_navigation.png": "69de",
	"./image/mobile_menu_icon.png": "43b5",
	"./image/mouseArrow.svg": "f58d",
	"./image/ms_b1_img1.png": "6402",
	"./image/ms_b1_img2.png": "23bc",
	"./image/ms_b1_img3.png": "096c",
	"./image/ms_b1_img4.png": "cc0d",
	"./image/ms_b2_pic1.png": "8254",
	"./image/ms_b2_pic2.png": "1fc5",
	"./image/ms_b2_pic3.png": "4855",
	"./image/ms_b2_pic4.png": "4009",
	"./image/ms_b3_img1.png": "8b51",
	"./image/ms_b3_img2.png": "897b",
	"./image/ms_b3_img3.png": "29db",
	"./image/ms_b3_img4.png": "a386",
	"./image/nav_application_lyjq.png": "b8f3",
	"./image/nav_application_sydc.png": "2dff",
	"./image/nav_application_xyxy.png": "2907",
	"./image/nav_application_yqly.png": "80f6",
	"./image/nav_application_zgcg.png": "c323",
	"./image/nav_b1_img1.png": "d051",
	"./image/nav_b1_img2.png": "2325",
	"./image/nav_b1_img3.png": "6f0b",
	"./image/nav_b1_img4.png": "e425",
	"./image/nav_b2_pic1.png": "c2d3",
	"./image/nav_b2_pic2.png": "19d3",
	"./image/nav_b2_pic3.png": "f10c",
	"./image/nav_b2_pic4.png": "a1fc",
	"./image/pd_b1_img1.png": "ee20",
	"./image/pd_b1_img2.png": "3f6a",
	"./image/pd_b1_img3.png": "ff8d",
	"./image/pd_b1_img4.png": "5c73",
	"./image/phone_icon.png": "8e6d",
	"./image/search_icon.png": "5169",
	"./image/search_icon_gray.png": "54df",
	"./image/service_icon.png": "d0bc",
	"./image/shanghaijunxiu.png": "108a",
	"./image/shanghaijunxiuLOGO.png": "f8ea",
	"./image/solution0.png": "4c33",
	"./image/solution1.png": "f27d",
	"./image/solution2.png": "b04a",
	"./image/solution3.png": "d253",
	"./image/solution4.png": "6b18",
	"./image/solutionBanner1.png": "2d17",
	"./image/solutionBanner2.png": "d3c4",
	"./image/solutionBanner3.png": "d476",
	"./image/solutionBanner4.png": "8415",
	"./image/solutionBanner5.png": "af84",
	"./image/solutionBanner_1.png": "8684",
	"./image/solutionBanner_2.png": "c696",
	"./image/solutionBanner_3.png": "680a",
	"./image/solutionBanner_4.png": "0aa2",
	"./image/solutionBanner_5.png": "0f7a",
	"./image/swiper1.png": "45f7",
	"./image/swiper2.png": "cc96",
	"./image/swiper3.png": "b92f",
	"./image/telephone_icon.png": "4e14",
	"./image/tianan.png": "83492",
	"./image/tiananLOGO.png": "19fc",
	"./image/train_icon.png": "b9ae",
	"./image/vanke_icon.png": "01fd",
	"./image/zhangjiagang.png": "e425e",
	"./image/zhangjiagangLOGO.png": "f9e9",
	"./logo.png": "cf05"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";